module.exports = __webpack_public_path__ + "assets/img/9326042073c842bfc3c848c84c979246.png";